import { Grid, TextField } from "@mui/material";
import CommonDialog from "../../common/commonDialog";

const LedgerApEditModal = (props) => {
  const { open, onCancel, onSave, ledgerRow, setLedgerRow } = props;

  const safeRow = ledgerRow || {
    vendorInvoiceValue: "",
    vendorPaymentReceiptValue: "",
    gstReturnFilingStatus: "",
    vendorRemarks: "",
  };

  const onInputChange = (event) => {
    const { name, value } = event.target;
    setLedgerRow((prev) => ({ ...prev, [name]: value }));
  };


  return (
    <CommonDialog
      onCancel={onCancel}
      onSave={onSave}
      open={open}
      primaryButtonLabel="Save"
      secondaryButtonLabel="Cancel"
      title="Edit Ledger"
      maxWidth="sm"
    >
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            label="Vendor Invoice Value"
            name="vendorInvoiceValue"
            size="small"
            type="text"
            value={safeRow.creditAmount ?? ""}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            label="Vendor Payment Receipt Value"
            name="vendorPaymentReceiptValue"
            size="small"
            type="text"
            value={safeRow.vendorPaymentReceiptValue ?? ""}
            onChange={onInputChange}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            label="GST Return Filing Status"
            name="gstReturnFilingStatus"
            size="small"
            value={safeRow.gstReturnFilingStatus ?? ""}
            onChange={onInputChange}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <TextField
            fullWidth
            label="Vendor Remarks"
            name="vendorRemarks"
            size="small"
            multiline
            rows={2}
            value={safeRow.vendorRemarks ?? ""}
            onChange={onInputChange}
          />
        </Grid>
      </Grid>
    </CommonDialog>
  );
};

export default LedgerApEditModal;
